export default function RelocationFeature() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#1A1F2E] to-[#2A3F5E]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-[#C9A961] text-white text-sm font-semibold rounded-full mb-6">
              New Service for UK Residents
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Saudi Relocation &amp; Long-Stay Travel from UK
            </h2>
            
            <p className="text-xl text-gray-200 mb-6 leading-relaxed">
              Planning a move to Saudi Arabia? We specialise in <strong className="text-white">relocation travel services</strong> for UK residents — flexible flights, temporary accommodation, and family planning support.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#C9A961] text-2xl mt-1"></i>
                <div>
                  <div className="text-white font-semibold mb-1">One-Way &amp; Flexible Flights</div>
                  <div className="text-gray-300 text-sm">Change options and extra baggage allowances</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#C9A961] text-2xl mt-1"></i>
                <div>
                  <div className="text-white font-semibold mb-1">Temporary Accommodation (4–12 Weeks)</div>
                  <div className="text-gray-300 text-sm">Serviced apartments in Riyadh, Jeddah, Dammam</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#C9A961] text-2xl mt-1"></i>
                <div>
                  <div className="text-white font-semibold mb-1">Family Relocation Planning</div>
                  <div className="text-gray-300 text-sm">Multi-generational travel coordination</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#C9A961] text-2xl mt-1"></i>
                <div>
                  <div className="text-white font-semibold mb-1">Return &amp; Contingency Travel</div>
                  <div className="text-gray-300 text-sm">Flexible UK return options and emergency travel</div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href="/saudi-relocation"
                className="inline-block px-8 py-4 bg-[#C9A961] text-white rounded-lg hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                Learn More About Relocation
              </a>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer font-semibold"
              >
                Book Consultation
              </a>
            </div>

            <div className="mt-8 flex items-center gap-6 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-[#C9A961]"></i>
                <span>ATOL Protected</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-[#C9A961]"></i>
                <span>24/7 UK Support</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-team-line text-[#C9A961]"></i>
                <span>1000+ Families Relocated</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[600px] w-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/723f731f59c808d42b01f95791eb743d.jpg"
                alt="Saudi Relocation Services"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-2xl max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <div className="text-3xl font-bold text-[#C9A961]">15+</div>
                <div>
                  <div className="font-bold text-[#1A1F2E]">Years Experience</div>
                  <div className="text-sm text-gray-600">Relocation Specialists</div>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                Trusted by UK residents for Saudi Arabia moves
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
